import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import FundosHome from '../fundos_home';
import CadastroFundo from '../fundo';

export type TipoFundo = 'liquidos' | 'estruturados';

/**
 * Ponto de entrada único de Fundos. A URL `/cadastro/fundo/:tipo` decide qual
 * tela renderizar conforme a seleção do usuário (item da sidebar):
 *   - liquidos     → FundosHome (módulo Fundos Líquidos)
 *   - estruturados → CadastroFundo (módulo Aquisição, fundos estruturados)
 * `:tipo` inválido cai no padrão (liquidos).
 */
const FundoDispatcher: React.FC = () => {
  const { tipo } = useParams<{ tipo: string }>();

  switch (tipo) {
    case 'liquidos':
      return <FundosHome />;
    case 'estruturados':
      return <CadastroFundo />;
    default:
      return <Navigate to="/cadastro/fundo/liquidos" replace />;
  }
};

export default FundoDispatcher;
